import React, { useEffect, useState } from 'react';
import callAPI from '../../commonservices/APIRequests';
import Toaster from '../Shared/Toaster/Toaster'
import { usePlaidLink } from 'react-plaid-link';
import { useNavigate } from 'react-router-dom';
import { Image, Button } from 'react-bootstrap';
import plaidwhitelogo from '../../assets/images/logo/plaid_white_logo.svg';

const PlaidData = (props) => {

  const navigate = useNavigate();
  const [linkToken, UpdateToken] = useState('');
  const [plaidEnvironment, setEnvironment] = useState(process.env.REACT_APP_ENVIRONMENT === 'production' ? 'production' : 'sandbox');
  const [toaster, setToaster] = useState({
    header: '',
    class: '',
    content: '',
    showToaster: false
  });

  let userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
  const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');
  const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};

  useEffect(() => {

    if (isOAuthRedirect) {
      UpdateToken(localStorage.getItem('link_token'));
      return;
    }
    if (partnerDetails && partnerDetails.enablePlaid)
      createLinkToken();

  }, []);

  const plaidEventHandler = (event) => {

    if (event === 'OPEN') {
      extendSession(true);
    }
    else if ((event === 'EXIT' || event === 'HANDOFF') && window.location.href.indexOf('oauth') > -1) {
      extendSession();
      if (partnerDetails && partnerDetails.enablePlaid)
        createLinkToken();
      navigate(window.location.pathname, { replace: true });
    }

  }

  const createLinkToken = () => {

    const reqCLT = {
      redirectUri: props.isFromOBF ? window.location.origin + '/DealerSignUp' : window.location.origin + '/Dealer/Profile'
    }

    if (props.dealerId)
      reqCLT.dealer_id = props.dealerId;

    callAPI.post('/payment/api/v1/plaid/createLinkToken', reqCLT)
      .then(response => {

        UpdateToken(response?.data?.plaid?.link_token)
        setEnvironment(response?.data?.plaidEnvironment);
        localStorage.setItem('link_token', response?.data?.plaid?.link_token);

      })
      .catch(error => {

        console.log(error)
      });

  }

  const toasterClose = () => {

    setToaster({
      header: '',
      class: '',
      content: '',
      showToaster: false
    })

  };



  const onExit = (error, metadata) => {


    // createLinkToken();
    console.log("error and exited", error);
    if (error && props.setplaidFailedStatus) {
      props.setplaidFailedStatus(true)
    }
    const req = {
      metadata: metadata,
      error: error,
      type: 'connect'
    }


    callAPI.post('/payment/api/v1/plaid/savePlaidLogs', req);

    props.closeLoader();
  }


  const saveIdentity = (accountId, _id) => {

    const req_identity = {
      accountId: accountId,
      _id: _id
    }
    if (props.dealerId)
      req_identity.dealer_id = props.dealerId;

    //Calling Identity API 
    callAPI.post('/payment/api/v1/plaid/saveIdentity', req_identity)
      .then(async () => {

      })
      .catch(error => {
        console.log(error);

      });

  }

  const onSuccess = async (token, metadata) => {

    // send public_token to your server
    props.setModalLoader(true);
    props.initiateLoader();
    await extendSession();

    const req = {
      metadata: metadata,
      error: {},
      type: 'connect'
    }

    callAPI.post('/payment/api/v1/plaid/savePlaidLogs', req);

    const reqSAT = {
      publicToken: token,
      metadata: metadata
    }

    const institutionId = metadata.institution.institution_id;
    const bankAccountId = metadata.account ? metadata.account.id : '';

    if (!bankAccountId) {
      props.setModalLoader(false);
      props.closeLoader();
      if (props.setplaidFailedStatus) {
        props.setplaidFailedStatus(true)
      }
      setToaster({
        header: 'Error',
        class: 'error-toaster',
        content: 'Failed to fetch bank account id',
        showToaster: true
      })
      return;
    }
    if (props.setPlaidLoader)
      props.setPlaidLoader(true);

    if (props.dealerId)
      reqSAT.dealer_id = props.dealerId;


    callAPI.post('/payment/api/v1/plaid/getAccessToken', reqSAT)
      .then(response => {
        // Local DB bank Id recived from response
        if (response.status === 200) {
          userDetails.showPlaidBanner = false;
          localStorage.setItem('user', JSON.stringify(userDetails));
          if (props.setPlaidConnectionRequiredStatus) {
            props.setPlaidConnectionRequiredStatus(false);
          }
        }
        const local_bank_id = response.data._id;
        saveIdentity(bankAccountId, local_bank_id);
        const bank_logo_req = {
          _id: local_bank_id,
          institutionId: institutionId
        }

        callAPI.post('/payment/api/v1/plaid/getBankLogo', bank_logo_req)
          .then(Logoresponse => {

            //Get Bank Balance from plaid account
            const bank_balance_req = {
              _id: local_bank_id,
              accountId: bankAccountId
            }

            callAPI.post('/payment/api/v1/plaid/getBankBalance', bank_balance_req)
              .then(balanceresponse => {

                // Get Bank Account number
                const bank_ac_Req = {
                  _id: local_bank_id,
                  accountId: bankAccountId
                }
                callAPI.post('/payment/api/v1/plaid/getBankAccountNumber', bank_ac_Req)
                  .then(async (account_response) => {
                    if (props.setDocumentModal && !account_response?.data?.documentsExists) {
                      props.setDocumentModal({ status: true, bankId: account_response?.data?.isUpdated ? account_response?.data?.oldBankId : local_bank_id , documents : account_response?.data?.documents});
                    }
                    await props.addBankAccount();
                    props.setModalLoader(false);
                    props.closeLoader();


                    // if (account_response && !account_response.data.isUpdated) {
                    //   // Update OR Save to SOPRA   
                    //   const sopra_save_req = {
                    //     _id: local_bank_id,
                    //   }


                    //   callAPI.post('/payment/api/v1/plaid/saveBankInSopra', sopra_save_req)
                    //     .then(async (sopraresponse) => {
                    //       // Do nothing in UI backend will call internally to SOPRA
                    //       await props.addBankAccount();

                    //     })
                    //     .catch(error => {
                    //       props.closeLoader();
                    //       props.setModalLoader(false);
                    //     });

                    //   props.closeLoader();
                    //   props.setModalLoader(false);
                    // }
                    // else {
                    //   await props.addBankAccount();
                    //   props.closeLoader();
                    //   props.setModalLoader(false);
                    // }
                  })
                  .catch(error => {
                    console.log(error);
                    props.closeLoader();
                    props.setModalLoader(false);
                  });

              })
              .catch(error => {
                props.closeLoader();
                props.setModalLoader(false);
              });

          })
          .catch(error => {
            props.closeLoader();
            props.setModalLoader(false);
          });

      })
      .catch(error => {
        if (props.setplaidFailedStatus) {
          props.setplaidFailedStatus(true);

        }
        props.closeLoader();
        props.setModalLoader(false);
      });
    // Update Link token to Work Add bank again
    // createLinkToken();



  }


  const extendSession = (extend45 = null) => {

    //2700 sec = 45 min

    return callAPI.post('/auth/api/v1/auth/keepActive', extend45 ? { customTime: 2700 } : {})
      .then((response) => {

        if (response.status === 200) {



        }
        else {

          console.log(response.message);

        }

      })

  }


  const config = {
    // token must be the same token used for the first initialization of Link
    token: linkToken,
    env: plaidEnvironment,
    onSuccess: onSuccess,
    onEvent: plaidEventHandler,
    onExit: onExit,
    onLoad: extendSession
  };
  if (isOAuthRedirect) {
    // receivedRedirectUri must include the query params
    config.receivedRedirectUri = window.location.href;
    config.token = localStorage.getItem('link_token');
  }
  const {
    open,
    ready,
    // error,
    // exit
  } = usePlaidLink(config);

  React.useEffect(() => {
    // If OAuth redirect, instantly open link when it is ready instead of
    // making user click the button
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  return (
    <React.Fragment>
      {
        toaster.showToaster ?
          <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
          : null
      }
      {isOAuthRedirect ? (
        <></>
      ) : (
        (partnerDetails && partnerDetails.enablePlaid) && !userDetails.readOnlyAccess ?
          <Button variant='primary' className='default-btn' onClick={() => open()} disabled={!ready}>
            {props.buttonLabel ? props.buttonLabel : <React.Fragment>
              <span className="mr-1">Connect to</span>
              <span><Image src={plaidwhitelogo} height={18} /></span>
            </React.Fragment>
            }
          </Button> : null
      )}

    </React.Fragment>
  )
}

export default PlaidData;